import { MEDIA } from "@/styles/common";
import { Box, Flex } from "@chakra-ui/react";
import { CustomWrapper } from "./checkCard.style";
import { Price, RoomInfo } from "./components";
import { CheckCardProps } from "./types";

export const CheckCard = ({ roomList, status }: CheckCardProps) => {
    const { roomName, mainThumbnailUrl, pay_all_total, pay_basic, person, schedule, basicManCount, period } = roomList;
    const { isMobile } = MEDIA();

    return (
        <CustomWrapper flexDir={isMobile ? "column" : "row"}>
            <Box
                background={`url('https://marginmax.me/up/room/${mainThumbnailUrl}')no-repeat center/cover`}
                w={isMobile ? "100%" : "264px"}
                h={"222px"}
                borderRadius={"8px"}
            ></Box>
            <Flex flex="1" justifyContent="space-between" flexDir={isMobile ? "column" : "row"} rowGap="24px">
                <RoomInfo roomName={roomName} person={person} schedule={schedule} status={status} />
                <Price
                    pay_all_total={pay_all_total}
                    pay_basic={pay_basic}
                    period={period}
                    basicManCount={basicManCount}
                    person={person}
                />
            </Flex>
        </CustomWrapper>
    );
};
